import { takeEvery, put, call, takeLatest } from "redux-saga/effects";

// Calender Redux States
import {
  ADD_NEW_EVENT,
  DELETE_EVENT,
  FETCH_EMPLOYEE_ATTENDANCE_POPUP_REQUEST,
  GET_CATEGORIES,
  GET_EVENTS,
  UPDATE_EVENT,
} from "./actionTypes";
import {
  getEventsSuccess,
  getEventsFail,
  addEventFail,
  addEventSuccess,
  updateEventSuccess,
  updateEventFail,
  deleteEventSuccess,
  deleteEventFail,
  getCategoriesSuccess,
  getCategoriesFail,
  fetchEmployeeAttendancePopupSuccess,
  fetchEmployeeAttendancePopupFailure,
} from "./actions";

//Include Both Helper File with needed methods
import {
  getEvents,
  addNewEvent,
  updateEvent,
  deleteEvent,
  getCategories,
} from "../../helpers/fakebackend_helper";
import { post } from 'helpers/api_helper';
import Swal from "sweetalert2";

function* fetchEvents() {
  try {
    const response = yield call(getEvents);
    yield put(getEventsSuccess(response));
  } catch (error) {
    yield put(getEventsFail(error));
  }
}

function* onAddNewEvent({ payload: event }) {
  try {
    const response = yield call(addNewEvent, event);
    yield put(addEventSuccess(response));
  } catch (error) {
    yield put(addEventFail(error));
  }
}

function* onUpdateEvent({ payload: event }) {
  try {
    const response = yield call(updateEvent, event);
    yield put(updateEventSuccess(response));
  } catch (error) {
    yield put(updateEventFail(error));
  }
}

function* onDeleteEvent({ payload: event }) {
  try {
    const response = yield call(deleteEvent, event);
    yield put(deleteEventSuccess(response));
  } catch (error) {
    yield put(deleteEventFail(error));
  }
}

function* onGetCategories() {
  try {
    const response = yield call(getCategories);
    yield put(getCategoriesSuccess(response));
  } catch (error) {
    yield put(getCategoriesFail(error));
  }
}

function* fetchEmployeeAttendanceSagaWorker(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_FETCH_EMPLOYEE_ATTENDANCE,
      action.payload
    );

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to fetch attendance!");
    }

    yield put({ type: "FETCH_EMPLOYEE_ATTENDANCE_SUCCESS", payload: response.data });
  } catch (error) {
    Swal.fire("Error", error.message, "error");
    yield put({ type: "FETCH_EMPLOYEE_ATTENDANCE_FAILURE", payload: error });
  }
}

function* fetchEmployeeAttendancePopupSaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_FETCH_EMPLOYEE_ATTENDANCE_POPUP,
      action.payload
    );

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to fetch popup details!");
    }

    yield put(fetchEmployeeAttendancePopupSuccess(response.data));
  } catch (error) {
    Swal.fire("Error", error.message, "error");
    yield put(fetchEmployeeAttendancePopupFailure(error));
  }
}

function* calendarSaga() {
  yield takeEvery(GET_EVENTS, fetchEvents);
  yield takeEvery(ADD_NEW_EVENT, onAddNewEvent);
  yield takeEvery(UPDATE_EVENT, onUpdateEvent);
  yield takeEvery(DELETE_EVENT, onDeleteEvent);
  yield takeEvery(GET_CATEGORIES, onGetCategories);
  yield takeLatest("FETCH_EMPLOYEE_ATTENDANCE_REQUEST", fetchEmployeeAttendanceSagaWorker);
  yield takeEvery(FETCH_EMPLOYEE_ATTENDANCE_POPUP_REQUEST, fetchEmployeeAttendancePopupSaga);
}

export default calendarSaga;
